export default __webpack_public_path__ + "static/media/frb.0c1ba194.png";